import React from 'react';
import { bool, string, node, func, oneOf, oneOfType } from 'prop-types';
import cx from 'classnames';

import Label from '../Label';
import Message from '../Message';

const CLASS_ROOT = 'radiocheck';

export default class RadioCheck extends React.Component {
  static displayName = 'RadioCheck';

  static propTypes = {
    /** Error state. If vaule is string, it's treated as error message. */
    error: oneOfType([bool, node]),
    /** Custom error renderer. Passes props as function parameter. */
    renderError: func,
    /** Html id attribute. */
    id: string.isRequired,
    /** Active state. */
    isActive: bool,
    /** Checked state. */
    isChecked: bool,
    /** Disabled state. */
    isDisabled: bool,
    /** Readonly state. */
    isReadonly: bool,
    /** Label text. */
    label: string,
    /** Custom label renderer. Passes props as function parameter. */
    renderLabel: func,
    /** Help text. */
    help: string,
    /** Custom help renderer. Passes props as function parameter. */
    renderHelp: func,
    /** Html name attribute. */
    name: string,
    /** Value change callback function */
    onChange: func,
    /** Size of element. */
    size: oneOf(['small', 'large']),
    /** Input html type */
    type: oneOf(['radio', 'checkbox']),
  };

  static defaultProps = {
    onChange: (newValue, e) => {}, // eslint-disable-line
  };

  handleChange = e => {
    let checked;
    if (e.target.type === 'checkbox') {
      checked = e.target.checked; // eslint-disable-line
    }

    if (e.target.type === 'radio') {
      checked = e.target.value;
    }

    this.props.onChange(checked, e);
  };

  render() {
    const {
      className,
      children,
      isActive,
      isChecked,
      isDisabled,
      isReadonly,
      error,
      renderError,
      help,
      renderHelp,
      id,
      label,
      renderLabel,
      onChange, // eslint-disable-line no-unused-vars
      size,
      type,
      ...other
    } = this.props;

    const classes = cx(
      CLASS_ROOT,
      type,
      {
        [`${CLASS_ROOT}--${size}`]: size,
      },
      className
    );

    const inputClasses = cx(`${CLASS_ROOT}__input`, {
      'is-active': isActive,
      'is-error': error,
    });

    const formControlClasses = cx('form-control', `form-control--${type}`);

    // set name from id if name is not specfied
    let { name } = other;
    name = name && id;

    const inputLabel =
      (renderLabel && renderLabel(this.props)) ||
      (label && (
        <Label id={id} size={size} isError={!!error}>
          {label}
        </Label>
      ));

    const helpMessage =
      (renderHelp && renderHelp(this.props)) ||
      (help && <Message type="help">{help}</Message>);

    const errorMessage =
      (renderError && renderError(this.props)) ||
      (error &&
        typeof error === 'string' && <Message type="error">{error}</Message>);

    return (
      <div className={formControlClasses}>
        <div className={classes}>
          {inputLabel}
          <input
            className={inputClasses}
            type={type}
            id={id}
            name={name}
            checked={isChecked}
            disabled={isDisabled}
            readOnly={isReadonly}
            onChange={this.handleChange}
            {...other}
          />
          <div className={`${CLASS_ROOT}__control`} />
          <label className={`${CLASS_ROOT}__label`} htmlFor={id}>
            {children}
          </label>
          {helpMessage}
          {errorMessage}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Forms/RadioCheck/RadioCheck.js